<template>
  <section class="hero is-primary is-fullheight">
    <div class="hero-body is-centered">
      <form
        class="columns is-multiline"
        @submit.prevent="onSubmit"
      >
        <div
          v-if="topUrlRedirect"
          class="column is-12 is-centered"
        >
          <a
            :href="topUrlRedirect"
            target="__blank"
          >
            <img
              :src="topBannerImg"
            >
          </a>
        </div>
        <div class="column is-12">
          <Receiver
            :is-loading="isLoading"
            :inline="true"
          />
        </div>
        <div class="column is-12">
          <PlainConcepts :is-loading="isLoading" />
        </div>

        <div class="column is-12 action-buttons">
          <div class="field is-grouped">
            <p class="control">
              <button
                type="submit"
                class="button is-success"
                :class="{ 'is-loading': isLoading }"
                :disabled="isLoading"
              >
                Generar Factura
              </button>
            </p>
          </div>
        </div>
        <div
          v-if="bottomUrlRedirect"
          class="column is-12 is-centered"
        >
          <a
            :href="bottomUrlRedirect"
            target="__blank"
          >
            <img
              :src="bottomBannerImg"
            >
          </a>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'NewInvoice',
  components: {
    Receiver: () => import(/* webpackChunkName: "invoice-receiver" */ '@/components/Admin/Invoices/NewInvoice/ReceiverAutoInvoice.vue'),
    PlainConcepts: () => import(/* webpackChunkName: "invoice-plain-concepts" */ '@/components/Admin/Invoices/PlainConcepts.vue'),
  },
  data() {
    return {
      isLoading: false,
      topUrlRedirect: '',
      topBannerImg: '',
      bottomUrlRedirect: '',
      bottomBannerImg: '',
    };
  },
  computed: {
    ...mapState({
      emitterRfc: state => state.invoice.emitterRfc,
      email: state => state.auth.email,
      stamped: state => state.invoice.operation.stamped,
      concepts: state => state.invoice.operation.concepts,
    }),
  },
  async beforeMount() {
    const topBanner = await this.getBanner('top');

    if (topBanner.payload) {
      this.topBannerImg = topBanner.payload.image;
      this.topUrlRedirect = topBanner.payload.url;
    }

    const bottomBanner = await this.getBanner('bottom');

    if (bottomBanner.payload) {
      this.bottomBannerImg = bottomBanner.payload.image;
      this.bottomUrlRedirect = bottomBanner.payload.url;
    }

    if (this.stamped) {
      this.$router.push({
        name: 'AutoInvoiceStamped',
        params: {
          id: this.$route.params.id,
        },
      });
    }

    if (!this.emitterRfc && !this.email) {
      this.isLoading = true;

      try {
        await this.initAuthentication();
      } catch (error) {
        this.$router.push({
          name: 'SignIn',
        });
      }

      const { stamped } = await this.getCustomerAutoInvoice(this.$route.params.id);
      this.isLoading = false;

      if (stamped) {
        this.$router.push({
          name: 'AutoInvoiceStamped',
          params: {
            id: this.$route.params.id,
          },
        });
      }
    }
  },
  mounted() {
    const [body] = document.getElementsByTagName('body');
    body.classList.add('auto-invoice');
  },
  beforeDestroy() {
    const [body] = document.getElementsByTagName('body');
    body.classList.remove('auto-invoice');
  },
  methods: {
    ...mapActions({
      saveInvoice: 'invoice/save',
      initAuthentication: 'auth/initAuthentication',
      getCustomerAutoInvoice: 'invoice/getCustomerAutoInvoice',
      updateCustomerAutoInvoice: 'invoice/updateCustomerAutoInvoice',
      getBanner: 'invoice/getBanner',
    }),
    async onSubmit() {
      const stamp = true;
      this.isLoading = true;
      try {
        await this.updateCustomerAutoInvoice({
          invoice: this.$route.params.id,
          stamp,
        });

        this.$store.dispatch('addTemporalNotification', {
          type: 'success',
          content: stamp ? 'Timbrado exitoso' : 'Guardado correctamente',
        });

        if (stamp) {
          this.$router.push({
            name: 'AutoInvoiceStamped',
            params: { id: this.$route.params.id },
          });
        }
      } catch (error) {
        this.$store.dispatch('addTemporalNotification', {
          type: 'danger',
          content: error.message,
        });
      }
      this.isLoading = false;
    },
  },
};
</script>

<style scoped>
.action-buttons {
  display: flex;
  justify-content: flex-end;
}

.hero-body {
  padding-bottom: 6rem;
}
</style>

<style>
body.auto-invoice .notifications-container {
  z-index: 100;
  position: fixed;
}
</style>
